import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCJmL4vk2-c2cxgeqLBKs21c8GsAs1DUnU',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'chicoseguro-9e6c1.firebaseapp.com',
  databaseURL:
    import.meta.env.VITE_FIREBASE_DATABASE_URL ||
    'https://chicoseguro-9e6c1-default-rtdb.firebaseio.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'chicoseguro-9e6c1',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'chicoseguro-9e6c1.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID || '973211836947',
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getDatabase(app)
export const googleProvider = new GoogleAuthProvider()

export const FIREBASE_API_KEY = firebaseConfig.apiKey
export const FIREBASE_DATABASE_URL = firebaseConfig.databaseURL
